import { Dispatch } from '../components/architecture/frontend/index'

import { gql } from '@apollo/client';
import { map, filter } from 'rxjs/operators'

import _ from 'lodash'


const GET_STATUSES = gql`
  query statuses {
    statuses {
      id
      name
      slug
      order
      process
      identifier
    }
  }
`;

Dispatch.getState('user.email')
  .pipe(
  )
  .subscribe(e => {
    if (_.isNil(e)) {
      Dispatch.nextState('statuses', null)
    }
    else {
      Dispatch.nextState('statuses', 'loading')
      Dispatch.nextAction('Request.statuses', { type: 'query', query: GET_STATUSES, variables: { }, poll: process.env.REACT_APP_POLL_INTERVAL,  retry: process.env.REACT_APP_RETRY_INTERVAL })
    }
  })

Dispatch.getAction('Response.statuses')
  .pipe(
    filter(e => _.isNil(e.errors)),
    map(e => e.data.statuses)
  )
  .subscribe(e => Dispatch.nextState('statuses', e))